export default [
  {
    path: '/chronicindex', // 慢病送药
    name: 'chronic',
    component: () => {
      return import(
        /* webpackChunkName: "medicineforchronic" */ '@/views/medicineForChronic/index.vue'
      )
    },
    meta: {
      title: '慢病送药',
      keepAlive: true
    }
  },
  {
    path: '/chronic/list', // 慢病送药
    name: 'chronicList',
    component: () => {
      return import(
        /* webpackChunkName: "medicineforchronic" */ '@/views/medicineForChronic/list.vue'
      )
    },
    meta: {
      title: '慢病送药'
    }
  },
  {
    path: '/chronic/apply', // 慢病送药申请
    name: 'chronicApply',
    component: () => {
      return import(
        /* webpackChunkName: "medicineforchronic" */ '@/views/medicineForChronic/apply.vue'
      )
    },
    meta: {
      title: '选择保单'
    }
  },
  {
    path: '/chronic/detailinfo', // 慢病送药详情
    name: 'chronicInfo',
    component: () => {
      return import(
        /* webpackChunkName: "medicineforchronic" */ '@/views/medicineForChronic/detailInfo.vue'
      )
    },
    meta: {
      title: '申请详情'
    }
  }
]
